import React, { useRef } from 'react';
import { WizardContent } from '../../wizard';
import type { WizardContentProps } from '../../types';
import { HouseholdsizeImage } from './householdsize-image';
import styles from './system-capacity.module.scss';
import { HouseTypeImage } from './housetype-image';
import { SliderVisual } from '@components/slider-visual/slider-visual';
import { QuestionCard } from '@components/question-card/question-card';

const mapHouseholdSizeToImageClassName = (householdSize?: string) => {
  switch (householdSize) {
    case 'EINPERSONEN_HAUSHALT':
      return 'one';
    case 'ZWEIPERSONEN_HAUSHALT':
      return 'two';
    case 'DREIPERSONEN_HAUSHALT':
      return 'three';
    case 'VIERPERSONEN_HAUSHALT':
      return 'four';
    case 'FUENF_ODER_MEHR_PERSONEN_HAUSHALT':
      return 'five';
    default:
      return '';
  }
};

const SystemCapcityGraphics: React.FC<{
  answers: PvWizardResultsQueryVariables;
  activeSlide: number;
}> = ({ answers, activeSlide }) => (
  <>
    {activeSlide === 0 && (
      <HouseTypeImage housetype={answers.houseType} className={styles.houseTypeImage} />
    )}
    {activeSlide === 1 && (
      <HouseholdsizeImage className={mapHouseholdSizeToImageClassName(answers.householdSize)} />
    )}
  </>
);

export const SystemCapacityWizardContent: React.FC<
  WizardContentProps<PvWizardResultSectionSystemCapacity>
> = ({
  questions,
  onAnswerUpdated,
  nextStep,
  previousStep,
  wizardState,
  result,
  sectionKey,
  sectionInfo
}) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <WizardContent
      itemTop={
        <SliderVisual
          summaryValue={`${result?.summary.value || 0} kWp`}
          summaryLabel={'Max. Anlagenleistung'}
          subline={`entspricht ${result?.summary.subline || 0} Solarmodulen`}
          sectionInfo={sectionInfo}
          containerAsRow
          modalRef={ref}
        >
          <SystemCapcityGraphics
            answers={wizardState.answers}
            activeSlide={wizardState.activeSlide}
          />
        </SliderVisual>
      }
      itemBottom={
        <QuestionCard
          sectionKey={sectionKey}
          activeQuestion={questions[wizardState.activeSlide]}
          onAnswerUpdated={onAnswerUpdated}
          previousStep={previousStep}
          showNextButton={false}
          nextStep={nextStep}
          wizardState={wizardState}
          showBackButton={wizardState.activeSlide !== 0}
        />
      }
      ref={ref}
    />
  );
};
